import { LoadingModal } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import Form from "components/Forms/Form";
import FormButtons from "components/Forms/FormButtons";
import { ModalFormFieldset } from "components/Forms/FormRenderers/ModalFormRenderer";
import AppModal from "components/common/AppModal";
import { injectModal } from "lib/injectParams";
import { useMemo } from "react";
import { FunderFormController } from "components/Pages/Funding/FunderFormController";

const NewFunderModal: React.FC<{ clubId: string }> = () => {
  const controller = FunderFormController.use();
  const { saving, loading } = controller.state;
  const fields = useMemo(() => Object.values(controller.fields()), [controller]);

  if (loading) return <LoadingModal title="New funder" />;

  return (
    <AppModal title="New funder" className="max-h-[80vh]">
      <Form name="funder">
        <fieldset disabled={saving}>
          <ModalFormFieldset fields={fields} />
        </fieldset>
        <FormButtons showDelete={false} saveTitle="Create" />
      </Form>
    </AppModal>
  );
};

export default injectModal(FunderFormController.scope(ApplicationView(NewFunderModal)));
